import './Footer.css';
import PageTraking from './PageTraking';

function Footer(props) {
	function _iub() {
		try {
			window._iub.cs.api.openPreferences()
		} catch (e) { };
		return false;
	}

	const currentYear = new Date().getFullYear();

	return (
		<>
			<div className="iol-contacts">
				<div className="iol-chatbot">
					<div className="iol-chatbot-wrapper iol_chat">
						<div className="icon-chatbot"></div>
					</div>
				</div>
				<div className="swiper-container contacts-carousel">
					<div className="swiper-wrapper">
						<div className="swiper-slide">
							<div className="contacts-text">
								<div className="icon">
									<div className="icon-message"> </div>
								</div><p className="semibold">Chatta con un nostro esperto</p>
								<div className="caption">Servizio attivo 8.30 - 19.00</div>
							</div><button className="darkblue-button link iol_chat">Apri la chat</button>
						</div>
						<div className="swiper-slide">
							<div className="contacts-text">
								<div className="icon">
									<div className="icon-phone"></div>
								</div><p className="semibold">Chiamaci al numero verde </p>
								<div className="caption">Servizio attivo 8.30 - 19.00</div>
							</div><a href="tel:800011411"><button className="darkblue-button link">800 011 411</button></a>
						</div>
						<div className="swiper-slide">
							<div className="contacts-text">
								<div className="icon">
									<div className="icon-headphones"></div>
								</div><p className="semibold">Ti chiamiamo noi</p>
								<div className="caption">Servizio attivo 8.30 - 19.00</div>
							</div><button className="darkblue-button link iol_callmenow">Inserisci numero</button>
						</div>
					</div>
					<div className="swiper-pagination"></div>
				</div>
			</div>

			{/* <!--INIZIO COMPONENTE CMN--> */}
{/* 			<div className="iol-content-overlay" id="iol-overlay-cmn">
				<div className="iol-overlay-inner">
					<div className="iol-weapper">
						<div className="iol-content-box">
							<p className="heading-4 fucsia-text semibold" id="cmn-title">Ti chiamiamo noi</p><p className="heading-5 semibold" id="cmn-msg">Compila i dati, un nostro esperto ti ricontatterà il prima possibile</p>
							<form className="row" id="cmn-form">
								<div className="form-group col-md-12" id="cmn-group-nome"><input className="form-control" type="nome" id="cmn-nome" aria-labelledby="nome" placeholder="c " max-lenght="50" /><span className="placeholder-text">Nome e cognome*</span>
									<div className="iol-error-label" id="cmn-nome-error"></div>
								</div>
								<div className="form-group col-md-12" id="cmn-group-telefono"><input className="form-control" type="numeroditelefono" id="cmn-telefono" aria-labelledby="numeroditelefono" placeholder="c " max-lenght="20" /><span className="placeholder-text">Numero di telefono*</span>
									<div className="iol-error-label" id="cmn-telefono-error"></div>
								</div>
								<div className="privacy-label caption">Proseguendo accetti di essere contattato e accetti la <span><a className="fucsia-text" target="_blank" href="/wp-content/plugins/iol-callmenow/docs/informativa privacy_call_me_now.pdf">Privacy Policy </a></span></div>
							</form><button className="fucsia-button link" id="cmn-btn-chiama">Richiamami</button>
							<button className="outline-button link cmn-btn-annulla">Annulla</button>
						</div>
					</div>
				</div>
			</div> */}

			{/* <!--FINE COMPONENTE CMN--> */}

			<footer>
				<div className="iol-footer-wrapper">
					<div className="footer__top">
						<div className="icon">
							<div className="icon-logo-mini"></div>
						</div>
						<div className="footer-top-links row">

							{/* <!-footer-links col-xl-3-> */}
							<div className="footer-links col-xl-3">
								{/* <!-start row-> */}
								<div className="row">
									<div className="footer-links__title link col-10 col-xl-12">Presenza</div>
									<div className="icon-plus col-2 col-xl-12"></div>
									{/* <!-start footer-links-list-> */}
									<div className="footer-links-list">
										<a className="heading-6 footer-link" href="/servizi/in-rete/">InRete</a>
										<a className="heading-6 footer-link" href="/servizi/ingrande/">InGrande</a>
									</div>
									{/* <!-end footer-links-list-> */}
								</div>
								{/* <!-end row-> */}
							</div>
							{/* <!-end footer-links col-xl-3-> */}
							{/* <!-footer-links col-xl-3-> */}
							<div className="footer-links col-xl-3">
								{/* <!-start row-> */}
								<div className="row">
									<div className="footer-links__title link col-10 col-xl-12">Sito web</div>
									<div className="icon-plus col-2 col-xl-12"></div>
									{/* <!-start footer-links-list-> */}
									<div className="footer-links-list">
										<a className="heading-6 footer-link" href="/servizi/sito-web-creato-da-noi/">Sito web</a>
									</div>
									{/* <!-end footer-links-list-> */}
								</div>
								{/* <!-end row-> */}
							</div>
							{/* <!-end footer-links col-xl-3-> */}
							{/* <!-footer-links col-xl-3-> */}
							<div className="footer-links col-xl-3">
								{/* <!-start row-> */}
								<div className="row">
									<div className="footer-links__title link col-10 col-xl-12">Ecommerce</div>
									<div className="icon-plus col-2 col-xl-12"></div>
									{/* <!-start footer-links-list-> */}
									<div className="footer-links-list">
										<a className="heading-6 footer-link" href="/servizi/e-commerce/">Ecommerce</a>
									</div>
									{/* <!-end footer-links-list-> */}
								</div>
								{/* <!-end row-> */}
							</div>
							{/* <!-end footer-links col-xl-3-> */}
							{/* <!-footer-links col-xl-3-> */}
							<div className="footer-links col-xl-3">
								{/* <!-start row-> */}
								<div className="row">
									<div className="footer-links__title link col-10 col-xl-12">Pubblicità online</div>
									<div className="icon-plus col-2 col-xl-12"></div>
									{/* <!-start footer-links-list-> */}
									<div className="footer-links-list">
										<a className="heading-6 footer-link" href="/servizi/pubblicita-online-creata-da-noi/">Pubblicita online</a>
										<a className="heading-6 footer-link" href="/servizi/pubblicita-su-network-italiaonline/">Pubblicita su Network Italiaonline</a>
									</div>
									{/* <!-end footer-links-list-> */}
								</div>
								{/* <!-end row-> */}
							</div>
							{/* <!-end footer-links col-xl-3-> */}
							{/* <!-footer-links col-xl-3-> */}
							<div className="footer-links col-xl-3">
								{/* <!-start row-> */}
								<div className="row">
									<div className="footer-links__title link col-10 col-xl-12">Social media e contenuti</div>
									<div className="icon-plus col-2 col-xl-12"></div>
									{/* <!-start footer-links-list-> */}
									<div className="footer-links-list">
										<a className="heading-6 footer-link" href="/servizi/social-media/">Social Media</a>
										<a className="heading-6 footer-link" href="/servizi/foto-video-professionali/">Foto e video professionali</a>
										<a className="heading-6 footer-link" href="/servizi/getione-recensioni-pro/">Moderazione professionale recensioni</a>
									</div>
									{/* <!-end footer-links-list-> */}
								</div>
								{/* <!-end row-> */}
							</div>
							{/* <!-end footer-links col-xl-3-> */}
							{/* <!-footer-links col-xl-3-> */}
							<div className="footer-links col-xl-3">
								{/* <!-start row-> */}
								<div className="row">
									<div className="footer-links__title link col-10 col-xl-12">Marketplace locali</div>
									<div className="icon-plus col-2 col-xl-12"></div>
									{/* <!-start footer-links-list-> */}
									<div className="footer-links-list">
										<a className="heading-6 footer-link" href="/servizi/paginegialle-casa/">PagineGialle Casa</a>
										<a className="heading-6 footer-link" href="/servizi/pagine-bianche-shop/">PagineGialle Shop</a>
									</div>
									{/* <!-end footer-links-list-> */}
								</div>
								{/* <!-end row-> */}
							</div>
							{/* <!-end footer-links col-xl-3-> */}
							{/* <!-footer-links col-xl-3-> */}
							<div className="footer-links col-xl-3">
								{/* <!-start row-> */}
								<div className="row">
									<div className="footer-links__title link col-10 col-xl-12">Gestione clienti</div>
									<div className="icon-plus col-2 col-xl-12"></div>
									{/* <!-start footer-links-list-> */}
									<div className="footer-links-list">
										<a className="heading-6 footer-link" href="/servizi/crm-creato-da-noi/">CRM - creato da noi</a>
									</div>
									{/* <!-end footer-links-list-> */}
								</div>
								{/* <!-end row-> */}
							</div>
							{/* <!-end footer-links col-xl-3-> */}
							{/* <!-footer-links col-xl-3-> */}
							<div className="footer-links col-xl-3">
								{/* <!-start row-> */}
								<div className="row">
									<div className="footer-links__title link col-10 col-xl-12">Pubblicità TV e Cinema</div>
									<div className="icon-plus col-2 col-xl-12"></div>
									{/* <!-start footer-links-list-> */}
									<div className="footer-links-list">
										<a className="heading-6 footer-link" href="/servizi/tv-cinema/">TV e Cinema</a>
									</div>
									{/* <!-end footer-links-list-> */}
								</div>
								{/* <!-end row-> */}
							</div>
							{/* <!-end footer-links col-xl-3-> */}
							{/* <!-footer-links col-xl-3-> */}
							<div className="footer-links col-xl-3">
								{/* <!-start row-> */}
								<div className="row">
									<div className="footer-links__title link col-10 col-xl-12">Prodotti per la tua azienda</div>
									<div className="icon-plus col-2 col-xl-12"></div>
									{/* <!-start footer-links-list-> */}
									<div className="footer-links-list">
										<a className="heading-6 footer-link" href="/servizi/gadget-personalizzati/">Gadget personalizzati</a>
									</div>
									{/* <!-end footer-links-list-> */}
								</div>
								{/* <!-end row-> */}
							</div>
							{/* <!-end footer-links col-xl-3-> */}
							{/* <!-footer-links col-xl-3-> */}
							<div className="footer-links col-xl-3">
								{/* <!-start row-> */}
								<div className="row">
									<div className="footer-links__title link col-10 col-xl-12">Risorse</div>
									<div className="icon-plus col-2 col-xl-12"></div>
									{/* <!-start footer-links-list-> */}
									<div className="footer-links-list">
										<a className="heading-6 footer-link" href="/risorse/category/blog/">Blog</a>
										<a className="heading-6 footer-link" href="/risorse/category/guide/">Guide</a>
										<a className="heading-6 footer-link" href="/risorse/webinar/">Webinar</a>
										<a className="heading-6 footer-link" href="/risorse/category/bandi/">Bandi</a>
										<a className="heading-6 footer-link" href="/risorse/category/storie-di-successo/">Storie di successo</a>


									</div>
									{/* <!-end footer-links-list-> */}
								</div>
								{/* <!-end row-> */}
							</div>
							{/* <!-end footer-links col-xl-3-> */}

						</div>
					</div>
					<div className="footer__bottom">
						<div className="row">
							<div className="footer-utils col-lg-8 order-2 order-lg-1">
								<a className="footer-util heading-6 " href="https://www.italiaonline.it/archivio/informativa-privacy/" target="_blank" rel="noreferrer">Privacy</a>
								<a className="footer-util heading-6 iubenda-advertising-preferences-link" href="https://privacy.italiaonline.it/common/cookie/privacy_detail.php?from=banner" target="_blank" rel="noreferrer">Cookie Policy</a>
								<a className="footer-util heading-6" onClick={_iub}>Preferenze sui cookie</a>
								<a className="footer-util heading-6 " href="https://www.italiaonline.it/wp-content/uploads/2017/03/Documento-delle-caratteristiche-del-sistema-di-Firma-Elettronica-Avanzata-ai-sensi-dellart-57-DPCM-22-febbraio-2013-v-3-marzo-2017.pdf" target="_blank" rel="noreferrer">Firma Elettronica Avanzata</a>
							</div>
							<div className="footer-social col-md-4 order-1 order-md-2">
								<a className="icon" href="https://www.facebook.com/Italiaonline/" aria-label="Facebook" target="_blank" rel="noreferrer">
									<div className="icon-facebook"></div>
								</a>
								<a className="icon" href="https://www.instagram.com/italiaonline/" aria-label="Instagram" target="_blank" rel="noreferrer">
									<div className="icon-instagram"></div>
								</a>
								<a className="icon" href="https://www.youtube.com/channel/UCUs6QTUXQ1c96W0Taq_EFpA" aria-label="Youtube" target="_blank" rel="noreferrer">
									<div className="icon-youtube"></div>
								</a>
								<a className="icon" href="https://twitter.com/italiaonline_it/" aria-label="Twitter" target="_blank" rel="noreferrer">
									<div className="icon-twitter-x"></div>
								</a>
							</div>
						</div>
						<div className="iubenda-advertising-preferences-link"></div>
						<div className="footer-text caption">© Italiaonline {currentYear} - P. IVA 03970540963</div>
					</div>
				</div>
			</footer>
			<PageTraking pageTitle={props.pageTitle} />
		</>
	);
}

export default Footer;